const styles = {
  root: {},
  openCloseContainer: {
    
  }
}

export default styles
